/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */


/**
 * Automated process workflow parameter
 */
export enum AutomatedProcessParameter {
  FUNCTIONAL_POSITION_ID = 'FUNCTIONAL_POSITION_ID',
  MESSAGE_ID = 'MESSAGE_ID',
  DATABOX_SUBJECT = 'DATABOX_SUBJECT',
  EMAIL_SUBJECT = 'EMAIL_SUBJECT',
  DATABOX_ID = 'DATABOX_ID',
  DOCUMENT_SUBJECT = 'DOCUMENT_SUBJECT',
  FILE_SUBJECT = 'FILE_SUBJECT',
  SETTLEMENT_TYPE = 'SETTLEMENT_TYPE',
  DOCUMENT_UID = 'DOCUMENT_UID',
  RELATED_DOCUMENT_UID = 'RELATED_DOCUMENT_UID',
  FILE_UID = 'FILE_UID',
  DOCUMENT_ID = 'DOCUMENT_ID',
  FILE_ID = 'FILE_ID',
  EMAIL_ADDRESS = 'EMAIL_ADDRESS',
  ENTITY_CLASS_ID = 'ENTITY_CLASS_ID',
  SETTLEMENT_REASON = 'SETTLEMENT_REASON',
  SETTLEMENT_CONTENT = 'SETTLEMENT_CONTENT',
  NOTE = 'NOTE',
  SENDER_NAME = 'SENDER_NAME',
  SENDER_DATABOX_TYPE = 'SENDER_DATABOX_TYPE',
  SENDER_ADDRESS = 'SENDER_ADDRESS',
  SENDER_ORG_UNIT_NAME = 'SENDER_ORG_UNIT_NAME',
  SENDER_REF_NUM = 'SENDER_REF_NUM',
  RECIPIENT_DATABOX_ID = 'RECIPIENT_DATABOX_ID',
  TO_HANDS = 'TO_HANDS',
  AUTH_LAW_NO = 'AUTH_LAW_NO',
  AUTH_LAW_YEAR = 'AUTH_LAW_YEAR',
  AUTH_LAW_PARAGRAPH = 'AUTH_LAW_PARAGRAPH',
  AUTH_LAW_SECTION = 'AUTH_LAW_SECTION',
  AUTH_LAW_LETTER = 'AUTH_LAW_LETTER',
  PERSONAL_DELIVERY = 'PERSONAL_DELIVERY',
  DOCUMENT_FORM = 'DOCUMENT_FORM',
  DOCUMENT_KIND = 'DOCUMENT_KIND',
  DOCUMENT_TYPE = 'DOCUMENT_TYPE',
  DOCUMENT_LABEL = 'DOCUMENT_LABEL',
  DOCUMENT_STATE = 'DOCUMENT_STATE',
  KEYWORDS = 'KEYWORDS',
  SECURITY_CATEGORY_ID = 'SECURITY_CATEGORY_ID',
  DISPOSAL_SCHEDULE_ID = 'DISPOSAL_SCHEDULE_ID',
  CREATED_BY_FP_ID = 'CREATED_BY_FP_ID',
  MODIFIED_BY_FP_ID = 'MODIFIED_BY_FP_ID',
  OWNER_FP_ID = 'OWNER_FP_ID',
  OWNER_ORG_ID = 'OWNER_ORG_ID',
  HOLDER_FP_ID = 'HOLDER_FP_ID',
  HOLDER_ORG_ID = 'HOLDER_ORG_ID',
  DELIVERY_METHOD = 'DELIVERY_METHOD',
  ISSD_ID = 'ISSD_ID',
  ISSD_RETURN_REASON = 'ISSD_RETURN_REASON',
  FILE_FORM = 'FILE_FORM',
  FILE_TYPE = 'FILE_TYPE',
  FILE_REF_NUM = 'FILE_REF_NUM',
  FILE_REF_CREATION_TYPE = 'FILE_REF_CREATION_TYPE',
  FILE_STATUS = 'FILE_STATUS',
  RECIPIENT_ADDRESS = 'RECIPIENT_ADDRESS',
  DISPATCH_STATUS = 'DISPATCH_STATUS',
  REGISTRY_OFFICE_ID = 'REGISTRY_OFFICE_ID',
  FILE_CABINET_ID = 'FILE_CABINET_ID',
  GROUPING_ATTACHMENT_FORMAT = 'GROUPING_ATTACHMENT_FORMAT',
  ATTACHMENT_FORMAT_LIST = 'ATTACHMENT_FORMAT_LIST',
  ATTACHMENT_NAME_LIST = 'ATTACHMENT_NAME_LIST',
  CIRCULATION_TASK_INSTRUCTION = 'CIRCULATION_TASK_INSTRUCTION',
  CIRCULATION_TARGET_FP_IDS = 'CIRCULATION_TARGET_FP_IDS',
  CIRCULATION_INSTRUCTION = 'CIRCULATION_INSTRUCTION',
  CIRCULATION_DEADLINE = 'CIRCULATION_DEADLINE',
  CIRCULATION_FLOW_TYPE = 'CIRCULATION_FLOW_TYPE',
}
